// @flow
// @jsx h
import inViewport from 'in-viewport'

import Vue from 'vue'
import store from 'app/store'
import Comments from 'app/components/comments/comments.vue'
import { router } from 'app/store'
import commentState from 'app/store/comments/state'

export const CommentsView = new Vue({
  components: { Comments },
  store,
  router,
  data: {
    main: {},
  },
  beforeMount() {
    this.$store.registerModule('comments', commentState)

    const { commit } = this.$store

    commit('setCommentTotal', Laravel.commentCount)
    commit('setCommentable', {
      commentableType: Laravel.entity && Laravel.entity.type,
      commentableId: Laravel.entity && Laravel.entity.id,
    })
  },
  mounted() {
    const { dispatch } = this.$store

    const elem = document.getElementById('comments')

    inViewport(elem, () => {
      if (Laravel.commentId) {
        dispatch({
          type: 'getInitialComment',
          commentId: Laravel.commentId,
        })
      } else {
        dispatch({
          type: 'getInitialComments',
        })
      }
    })
  },
  render(h) {
    return <Comments />
  },
})
